/**
 * Run callback when the page is shown: now, if the page has already loaded,
 * and again on every later pageshow (e.g. returning with the back button).
 *
 * Cookiebot's auto-blocking mode holds every DOMContentLoaded handler until
 * after the page has loaded, by which time the first pageshow has already
 * fired. A pageshow listener registered inside one of those handlers would
 * therefore never run on a fresh load.
 */
export function onPageShow(callback)
{
    if (document.readyState === "complete")
    {
        callback();
    }

    window.addEventListener("pageshow", callback);
}
